import axios from "axios";

export const getPeripheralTypesAPI = async () => {
  let response = await axios({
    url: `/api/v2/admin-utility/peripherals`,
    method: "GET"
  });
  return response.data.peripheral_types;
};
